import { Grid, Switch, TextareaAutosize, Typography } from "@material-ui/core";
import { useEffect, useState } from "react";
import SwipeableViews from "react-swipeable-views";

import AccountCargoDetails from "../../../../../components/Calculator/AccountCargoDetails";
import ActionButtons from "../../../../../components/Calculator/ActionButtons";
import BunkerSupplyMarginAllowance from "../../../../../components/Calculator/BunkerSupplyMarginAllowancesTable";
import CalculatorVesselDetails from "../../../../../components/Calculator/CalculatorVesselDetails";
import DailyExpensesModal from "../../../../../components/Calculator/DailyExpensesModal";
import Expenses from "../../../../../components/Calculator/Expenses";
import MarginAndAllowances from "../../../../../components/Calculator/MarginAndAllowances";
import MarginAllowancesTable from "../../../../../components/Calculator/MarginAllowancesTable";
import PortOperations from "../../../../../components/Calculator/PortOperations";
import Result from "../../../../../components/Calculator/Result";
import SplitHireModal from "../../../../../components/Calculator/SplitHireModal";
import CustomShowModal from "../../../../../components/Common/CustomShowModal";
import { EstimateToContractStepper } from "../../../AllMatrix/estimateTocontractStepper";
import ShowMap from "../../ShowMap";

import { useSingleVesselController } from "../hooks/useSingleVesselController";

export default function SingleVesselView(props) {
  const { setLoader = () => { }, setIsFullScreen = () => { } } = props;
  const [marginModal, setMarginModal] = useState(false);
  const controller = useSingleVesselController(props);

  const {
    calculatorData,
    selectedVessels,
    syncBunker,
    isOverride,
    activeTab,
    setActiveTab,
    showSplitHireModal,
    setShowSplitHireModal,
    supplyModal,
    setSupplyModal,
    openAddOperation,
    setOpenAddOperation,
    setOpenAddOperationindex,
    showExpensesModal,
    setShowExpensesModal,
    fleetCheckbox,
    setFleetCheckbox,
    swipeableActions,
    calculationErrors,

    // Contract state
    isStepperOpen,
    vesselFormData,
    setVesselFormData,
    cargoFormData,
    setCargoFormData,
    cargoAttachments,
    vesselAttachments,
    modelType,
    selectedEstimate,
    estimateFormData,
    setEstimateFormData,
    cargoTextContract,
    vesselTextContract,
    setCargoTextContract,
    setVesselTextContract,

    // Actions & Handlers
    getInitialData,
    onChangeSelectedVessel,
    onChangePortOperations,
    onAddOperations,
    onDeleteOperations,
    onFetchPortOperationDistance,
    onChangeBunkerScrubber,
    onChangeSyncBunker,
    onChangeClientQuery,
    onClickCalculate,
    onClickCalculateAndSave,
    onSetOpenMap,
    addRow,
    onChangeSplitHire,

    handleOpenModelForCreateContract,
    handleCargoAttachmentUpload,
    handleVesselAttachmentUpload,
    handleCargoDataChange,
    handleVesselDataChange,
    handleVesselTextContractUpload,
    handleCargoTextContractUpload,
    removeCargoAttachment,
    removeVesselAttachment,
    saveCargoVesselContract,
    setInitialState,
    setCalculatorData,
    setSelectedVessel,
    setIsOverride,
  } = controller;

  const tabs = ["Port Operations", "Bunker & Margin Allowance"];

  useEffect(() => {
    if (swipeableActions.current) {
      setTimeout(() => {
        if (swipeableActions.current) {
          swipeableActions.current.updateHeight();
        }
      }, 100);
    }
  }, [calculatorData.portOperation, activeTab, swipeableActions]);

  const handleTabChange = (index) => setActiveTab(index);
  const handleSwipeChange = (index) => setActiveTab(index);

  return (
    <Grid className="calculator-section px-2.5 pt-1 pb-2">
      <Grid item xs={12}>
        <div className="quick-menu-bar">
          <ActionButtons
            isFromSingleVesselCalcy={true}
            IsQuerySelected
            onSetOpenMap={onSetOpenMap}
            onClickCalculate={onClickCalculate}
            onClickCreateContract={handleOpenModelForCreateContract}
            onClickCalculateAndSave={onClickCalculateAndSave}
          />
        </div>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={4} md={2}>
            <div className="upper-section-grid bg-white border border-[#cbd5e1] min-h-full">
              <AccountCargoDetails
                isFromSingleVesselCalcy={true}
                calculatorData={calculatorData}
                setLoader={setLoader}
                IsEditable
                getInitialData={getInitialData}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={8} md={4}>
            <div className="upper-section-grid bg-white border border-[#cbd5e1] min-h-full">
              <CalculatorVesselDetails
                setLoader={setLoader}
                setSelectedVessels={setSelectedVessel}
                selectedVessels={selectedVessels}
                calculatorData={calculatorData}
                setCalculatorData={setCalculatorData}
                onChangeHandler={onChangeSelectedVessel}
                fleetCheckbox={fleetCheckbox}
                setFleetCheckbox={setFleetCheckbox}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <div className="upper-section-grid bg-white border border-[#cbd5e1] min-h-full">
              <MarginAndAllowances
                isFromSingleVesselCalcy={true}
                onChangeSelectedVessel={onChangeSelectedVessel}
                selectedVessels={selectedVessels}
                setSelectedVessels={setSelectedVessel}
                setMarginModal={setMarginModal}
                calculatorData={calculatorData}
                setCalculatorData={setCalculatorData}
                syncBunker={syncBunker}
                setSyncBunker={onChangeSyncBunker}
                setSupplyModal={setSupplyModal}
                onChangeSyncBunker={onChangeSyncBunker}
                isOverride={isOverride}
                setIsOverride={setIsOverride}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <div className="upper-section-grid bg-white border border-[#cbd5e1] min-h-full">
              <Expenses
                isFromSingleVesselCalcy={true}
                onChangeSelectedVessel={onChangeSelectedVessel}
                selectedVessels={selectedVessels}
                openSplitHireModal={() => setShowSplitHireModal(true)}
                calculatorData={calculatorData}
                setCalculatorData={setCalculatorData}
                setShowExpensesModal={setShowExpensesModal}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <div className="upper-section-grid bg-white border border-[#cbd5e1] min-h-full">
              <Result
                selectedVessels={selectedVessels}
                calculationErrors={calculationErrors}
              />
            </div>
          </Grid>

          <div className="w-full mt-2 mb-1">
            <div className="flex flex-wrap justify-between items-end gap-y-1 relative z-10 w-full">
              <div className="flex space-x-1 items-end">
                {tabs.map((tab, index) => {
                  const isActive = activeTab === index;
                  return (
                    <button
                      key={index}
                      onClick={() => handleTabChange(index)}
                      className={`
                        group relative px-3 sm:px-5 py-1 text-xs font-semibold whitespace-nowrap rounded-t-lg transition-all duration-200 ease-out focus:outline-none
                        ${isActive
                          ? "bg-[#313C4C] text-white translate-y-[1px]"
                          : "bg-slate-200/50 text-slate-500 hover:bg-slate-200 hover:text-slate-700 border-x border-t border-transparent pb-1.5"
                        }
                      `}
                    >
                      {tab}
                    </button>
                  );
                })}
              </div>

              {activeTab === 1 && (
                <div className="flex flex-wrap items-center gap-x-4 gap-y-1 mb-1 mr-0 sm:mr-4 px-2 sm:px-0 w-full sm:w-auto text-[11px]">
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span style={{ marginRight: "6px", fontSize: "11px", fontWeight: 500, color: "#000000" }}>TC Adcom %:</span>
                    <input
                      type="number"
                      name="tcAdcom"
                      className="focus:outline focus:outline-[1.5px] focus:outline-[#d97706] focus:-outline-offset-[1.5px] focus:bg-white"
                      style={{
                        width: "60px",
                        border: "1px solid #a3b8cb",
                        height: "19px",
                        padding: "0 4px",
                        fontSize: "11px",
                        fontWeight: 500,
                        color: "#000000",
                        borderRadius: "2px",
                        outline: "none",
                      }}
                      value={calculatorData?.clientQuery?.tcAdcom || ""}
                      onChange={onChangeClientQuery}
                    />
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <label style={{ fontSize: "11px", fontWeight: 500, color: "#000000", marginRight: "4px", margin: 0, cursor: "pointer" }}>
                      Allow Fuel Price Adjustments
                    </label>
                    <Switch
                      size="small"
                      checked={syncBunker}
                      onChange={(e) => onChangeSyncBunker(e.target.checked)}
                      name="checkedA"
                      color="primary"
                      style={{ margin: 0 }}
                    />
                  </div>
                </div>
              )}
            </div>

            <div className="shadow-[0_8px_30px_rgb(0,0,0,0.04)] relative z-0 overflow-hidden">
              <SwipeableViews
                index={activeTab}
                onChangeIndex={handleSwipeChange}
                className="w-full"
                animateHeight
                action={(actions) => {
                  swipeableActions.current = actions;
                }}
              >
                <div className="p-0">
                  <div className="middle-section-grid">
                    <PortOperations
                      sendCalculationRequest={controller.sendCalculationRequest}
                      onChangePortOperations={onChangePortOperations}
                      calculatorData={calculatorData}
                      setCalculatorData={setCalculatorData}
                      onAddOperations={onAddOperations}
                      syncBunker={syncBunker}
                      onDeleteOperations={onDeleteOperations}
                      setSupplyModal={setSupplyModal}
                      selectedVessels={selectedVessels}
                      isOverride={isOverride}
                      setIsOverride={setIsOverride}
                      supplyModal={supplyModal}
                      onFetchPortOperationDistance={onFetchPortOperationDistance}
                      onChangeSelectedVessel={onChangeSelectedVessel}
                      fetchPortDistance={controller.fetchPortDistance}
                      openAddOperation={openAddOperation}
                      setOpenAddOperation={setOpenAddOperation}
                      setOpenAddOperationindex={setOpenAddOperationindex}
                      onReorderOperation={controller.handleReorderOperation}
                    />
                  </div>
                </div>
                <div className="p-0">
                  <div>
                    <BunkerSupplyMarginAllowance
                      onChangeClientQuery={onChangeClientQuery}
                      portOperation={calculatorData.portOperation}
                      syncBunker={syncBunker}
                      setSyncBunker={onChangeSyncBunker}
                      clientQuery={selectedVessels?.clientQuery}
                      onChangeBunkerScrubber={onChangeBunkerScrubber}
                      selectedVessels={selectedVessels}
                      onChangeSyncBunker={onChangeSyncBunker}
                      onChangeSelectedVessel={onChangeSelectedVessel}
                      onChangePortOperations={onChangePortOperations}
                      isOverride={isOverride}
                      setIsOverride={setIsOverride}
                      calculatorData={calculatorData}
                      setCalculatorData={setCalculatorData}
                    />
                  </div>
                </div>
              </SwipeableViews>
            </div>
          </div>

          <CustomShowModal
            open={showExpensesModal}
            handleClose={() => setShowExpensesModal(false)}
            title="Expenses Per Day"
          >
            <DailyExpensesModal
              calculatorData={calculatorData}
              setCalculatorData={setCalculatorData}
              dailyExpenses={calculatorData?.clientQuery?.dailyExpenses}
              open={showExpensesModal}
            />
          </CustomShowModal>

          <CustomShowModal
            open={showSplitHireModal}
            handleClose={() => setShowSplitHireModal(false)}
            title="Split Hire"
          >
            <SplitHireModal
              addNewSplitHire={addRow}
              selectedSplitHire={calculatorData.fleetList?.[0]}
              onChangeSplitHire={onChangeSplitHire}
            />
          </CustomShowModal>

          <CustomShowModal
            open={marginModal}
            handleClose={() => setMarginModal(false)}
            maxWidth="sm"
            title="Margin Allowances Table"
          >
            <MarginAllowancesTable
              calculatorData={calculatorData}
              setCalculatorData={setCalculatorData}
            />
          </CustomShowModal>

          <Grid container spacing={2} className="mb-10">
            <Grid item xs={12}>
              <div className="p-4 bg-white rounded-lg shadow-sm">
                <div className="selected-vessel-remark">
                  <Typography variant="subtitle1" component="p" className="font-medium">
                    Remarks:
                    <TextareaAutosize
                      id="remark"
                      name="remark"
                      minRows={2}
                      maxRows={8}
                      placeholder="N/A"
                      className="flex-1 w-full bg-transparent border-none text-base border-b border-transparent 
                        hover:border-gray-200 focus:border-blue-500 focus:outline-none 
                        transition-colors py-1 text-gray-800 scroll-thin resize-none"
                      value={selectedVessels?.remark || ""}
                      onChange={(e) => onChangeSelectedVessel(e, true)}
                    />
                  </Typography>
                </div>
              </div>
            </Grid>
          </Grid>

          {calculatorData?.clientQuery?._id &&
            calculatorData?.clientQuery?.portToPortDistance?.output &&
            Object.keys(calculatorData?.clientQuery?.portToPortDistance?.output || {}).length > 0 && (
              <Grid item xs={12}>
                <div className="flex justify-center items-center">
                  <div className="h-[700px] w-full overflow-hidden">
                    <ShowMap
                      showSidebar={false}
                      setIsFullScreen={setIsFullScreen}
                      id={calculatorData?.clientQuery?._id}
                      portDistanceResponse={calculatorData?.clientQuery?.portToPortDistance?.output}
                      portOperation={calculatorData?.portOperation}
                      fleetList={calculatorData?.fleetList}
                    />
                  </div>
                </div>
              </Grid>
            )}

          <CustomShowModal
            open={isStepperOpen}
            handleClose={() => setInitialState()}
            title={"Create Contract"}
            maxWidth="md"
            saveLabel={"Create"}
            hideButtons={true}
          >
            <EstimateToContractStepper
              vesselFormData={vesselFormData}
              setVesselFormData={setVesselFormData}
              cargoFormData={cargoFormData}
              setCargoFormData={setCargoFormData}
              cargoAttachments={cargoAttachments}
              vesselAttachments={vesselAttachments}
              handleCargoAttachmentUpload={handleCargoAttachmentUpload}
              handleVesselAttachmentUpload={handleVesselAttachmentUpload}
              handleCargoDataChange={handleCargoDataChange}
              handleVesselDataChange={handleVesselDataChange}
              handleVesselTextContractUpload={handleVesselTextContractUpload}
              handleCargoTextContractUpload={handleCargoTextContractUpload}
              modelType={modelType}
              selectedEstimate={selectedEstimate}
              removeCargoAttachment={removeCargoAttachment}
              removeVesselAttachment={removeVesselAttachment}
              estimateFormData={estimateFormData}
              setEstimateFormData={setEstimateFormData}
              handleFinish={saveCargoVesselContract}
              setCargoTextContract={setCargoTextContract}
              setVesselTextContract={setVesselTextContract}
              cargoTextContract={cargoTextContract}
              vesselTextContract={vesselTextContract}
            />
          </CustomShowModal>
        </Grid>
      </Grid>
    </Grid>
  );
}
